import {ButtonIconTooltip, HStack, PencilIcon, TrashIcon, VStack} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback} from "react";

import type {Bedroom} from "../type";

import BedName from "./BedName";

import {TableCell, TableRow} from "@/client/components/Table";
import Text from "@/client/components/Text";

type Props = {
    bedroom: Bedroom;
    index: number;
    onEdit: (bedroom: Bedroom, index: number) => void;
    onRemove: (index: number) => void;
};

const BedroomsItem: React.FC<Props> = ({bedroom, index, onEdit, onRemove}) => {
    const handleEdit = useCallback(() => {
        onEdit(bedroom, index);
    }, [bedroom, index, onEdit]);

    const handleRemove = useCallback(() => {
        onRemove(index);
    }, [index, onRemove]);

    return (
        <TableRow>
            <TableCell>{bedroom?.type}</TableCell>
            <TableCell>
                <VStack space="xs">
                    {bedroom?.beds?.bed?.map(bed => (
                        <Text key={bed.bedType} variant="xs">
                            <BedName bed={bed} />
                        </Text>
                    ))}
                </VStack>
            </TableCell>
            <TableCell>
                <VStack space="xs">
                    {bedroom?.beds?.bed?.map(bed => (
                        <Text key={bed.bedType} variant="xs">
                            {bed?.count}
                        </Text>
                    ))}
                </VStack>
            </TableCell>
            <TableCell>{bedroom?.privateBathroom ? "Yes" : "No"}</TableCell>
            <TableCell align="end">
                <HStack className="items-end justify-end">
                    <ButtonIconTooltip icon={PencilIcon} tooltip="Edit" onPress={handleEdit} />
                    <ButtonIconTooltip icon={TrashIcon} tooltip="Remove" onPress={handleRemove} />
                </HStack>
            </TableCell>
        </TableRow>
    );
};

export default memo(BedroomsItem);
